module.exports = __webpack_public_path__ + "img/icon_do_location@2x.2c71c633.png";